import React, { useEffect, useState } from "react";
import { IconButton } from "@fluentui/react";
import { Application, getApplications } from "@/api/applications";
import ApplicationDetailList from "@/components/applications/ApplicationDetailList";
import NewApplication from "@/components/applications/NewApplication";
import ShimmerList from "@/ui-controls/ShimmerList";
import SearchBox from "@/ui-controls/SearchBox";

const ApplicationsPage = () => {
  const [applications, setApplications] = useState<Application[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [filteredApplications, setFilteredApplications] = useState<
    Application[]
  >([]);
  const [isSearchPerformed, setIsSearchPerformed] = useState<boolean>(false);

  useEffect(() => {
    getAllApplications();
  }, []);

  const getAllApplications = () => {
    setLoading(true);
    getApplications()
      .then((result) => {
        setApplications(result);
        setLoading(false);
      })
      .catch((error) => {
        handleError(error);
        setLoading(false);
      });
  };

  const handleError = (error: any) => {
    // Error handling would go here in real app
  };

  const handleRefresh = () => {
    getAllApplications();
    // Clear search if performed
    if (isSearchPerformed) {
      setIsSearchPerformed(false);
      setFilteredApplications([]);
    }
  };

  // Function to handle search
  const handleSearch = (searchValue: string) => {
    setIsSearchPerformed(true);

    // Filter applications based on Name and Description headers
    const filteredApps = applications.filter(
      (app) =>
        app.Name.toLowerCase().includes(searchValue.toLowerCase()) ||
        (app.Description &&
          app.Description.toLowerCase().includes(searchValue.toLowerCase()))
    );

    setFilteredApplications(filteredApps);
  };

  return (
    <>
      <div className="page-header">
        <h2 className="page-title">
          Applications
        </h2>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <NewApplication
            onSave={(app) => setApplications((prev) => [...prev, app])}
            disabled={loading}
          />
          <SearchBox placeholder="Search" onSearch={handleSearch} disabled={loading} />
          <IconButton
            iconProps={{ iconName: "Refresh" }}
            title="Refresh"
            ariaLabel="Refresh"
            onClick={handleRefresh}
            disabled={loading}
            styles={{
              root: { width: 40, height: 40 },
              rootHovered: { backgroundColor: "#f3f2f1" },
              icon: {
                fontSize: 18,
                color: loading ? "#a19f9d" : "#0078d4",
              },
              rootPressed: { backgroundColor: "#e1dfdd" },
              rootDisabled: { backgroundColor: "transparent" },
            }}
          />
        </div>
      </div>
      {loading ? (
        <ShimmerList numberOfColumns={8} />
      ) : (
        <ApplicationDetailList
          ApplicationList={
            isSearchPerformed
              ? filteredApplications.length === 0
                ? []
                : filteredApplications
              : applications
          }
          onUpdate={(app) => {
            setApplications((prev) =>
              prev.map(
                (app1) => [app].find((app2) => app2.Id === app1.Id) || app1
              )
            );
            setFilteredApplications((prev) =>
              prev.map(
                (app1) => [app].find((app2) => app2.Id === app1.Id) || app1
              )
            );
          }}
          onDelete={(app) => {
            setApplications((prev) => prev.filter((a) => a.Id !== app.Id));
            // Also remove the deleted app from filteredApplications if it's there
            setFilteredApplications((prev) =>
              prev.filter((a) => a.Id !== app.Id)
            );
          }}
        />
      )}
    </>
  );
};

export default ApplicationsPage;
